export default __webpack_public_path__ + "lib/button-border-active.acf6a9a459667d52875614226c892f4d.svg";